import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

export const BgVideo = forwardRef(({ src, poster, className = "", testId }, ref) => {
  const el = useRef(null);
  useImperativeHandle(ref, () => el.current);

  useEffect(() => {
    const v = el.current;
    if (!v) return undefined;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute("muted", "");
    const tryPlay = () => { v.play().catch(() => {}); };
    tryPlay();
    v.addEventListener("canplay", tryPlay, { once: true });
    return () => v.removeEventListener("canplay", tryPlay);
  }, [src]);

  const webm = src.replace(/\.mp4$/, ".webm");
  return (
    <video
      ref={el}
      data-testid={testId}
      className={className}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
    >
      <source src={webm} type="video/webm" />
      <source src={src} type="video/mp4" />
    </video>
  );
});
BgVideo.displayName = "BgVideo";
